import * as React from 'react';

import useUrlState from '@ahooksjs/use-url-state';
import { useGetState, useMemoizedFn, useRequest } from 'ahooks';
import { Helmet } from 'react-helmet-async';

import { searchTags } from 'services';
import { PATHNAME } from 'utils';

import { TagsHeader, TagsTable } from './components';

const {
  QUERY_PARAM: {
    DEFAULT: { PAGE_NUMBER: DEFAULT_PAGE_NUMBER, PAGE_SIZE: DEFAULT_PAGE_SIZE },
    SEARCH_KEY: { BASE_URL: SEARCH_KEY_BASE_URL },
    PAGE_NUMBER: { BASE_URL: PAGE_NUMBER_BASE_URL },
  },
} = PATHNAME;

export default function Tags() {
  const [
    { [SEARCH_KEY_BASE_URL]: searchKey, [PAGE_NUMBER_BASE_URL]: pageNumber },
    setUrlState,
  ] = useUrlState(
    {
      [SEARCH_KEY_BASE_URL]: '',
      [PAGE_NUMBER_BASE_URL]: DEFAULT_PAGE_NUMBER,
    },
    { navigateMode: 'replace' },
  );
  const [pageSize, setPageSize] = useGetState<number>(DEFAULT_PAGE_SIZE);
  const { data, loading, refresh } = useRequest(
    async () =>
      await searchTags({
        searchKey,
        pageNumber,
        pageSize,
      }),
    {
      refreshDeps: [searchKey, pageNumber, pageSize],
    },
  );

  const { total = 0, data: tags = [] } = data ?? {};

  const handleSearchKey = useMemoizedFn((updatedSearchKey: string) => {
    setUrlState({ [SEARCH_KEY_BASE_URL]: updatedSearchKey });
  });
  const handlePageNumber = useMemoizedFn((updatedPageNumber: number) => {
    setUrlState({ [PAGE_NUMBER_BASE_URL]: updatedPageNumber });
  });
  const handlePageSize = useMemoizedFn((updatedPageSize: number) => {
    setPageSize(updatedPageSize);
  });

  return (
    <React.Fragment>
      <Helmet>
        <title>برچسب‌ها | کاشی لند</title>
      </Helmet>
      <div className='rounded bg-white p-6'>
        <TagsHeader searchKey={searchKey} handleSearchKey={handleSearchKey} />
        <TagsTable
          loading={loading}
          total={total}
          tags={tags}
          pageSize={pageSize}
          pageNumber={pageNumber}
          handlePageSize={handlePageSize}
          handlePageNumber={handlePageNumber}
          handleRefreshData={refresh}
        />
      </div>
    </React.Fragment>
  );
}
